import ButtonSelector from './styled';

export default ButtonSelector;
